import React from 'react';
import { Link } from 'react-router-dom';
export function SubNavigation({
  activeSection = null
}: {
  activeSection?: 'beef' | 'pork' | 'chicken' | null;
}) {
  const items = [{
    label: 'Market IQ',
    href: '/market-iq',
    section: null
  }, {
    label: 'Beef',
    href: '/market-iq/beef',
    section: 'beef' as const
  }, {
    label: 'Pork',
    href: '/market-iq/pork',
    section: 'pork' as const
  }, {
    label: 'Chicken',
    href: '/market-iq/chicken',
    section: 'chicken' as const
  }];
  return <nav className="py-2.5 border-b border-gray-300 bg-gray-50" data-id="element-255" data-mp="3i75dnn8druhz">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256" data-mp="3i5aq015q5oa7">
        <ul className="flex items-center gap-8 text-[14px] text-gray-700" data-id="element-257" data-mp="3d6zg5qffjdrz">
          {items.map((item, index) => {
          const isActive = item.section === activeSection;
          return <li key={index} data-id="element-258" data-mp="21ru806wj4n0z" data-mpi={index}>
                <Link to={item.href} className={`flex items-center gap-1 transition-colors ${isActive ? 'text-[#002f5f] font-semibold border-b-2 border-[#002f5f] pb-0.5' : 'hover:text-[#002f5f]'}`} data-id="element-259" data-mp="21uylxvzsqx4u">
                  {item.label}
                </Link>
              </li>;
        })}
        </ul>
      </div>
    </nav>;
}